<template>
  <div>
    <v-card class="ma-0 justify-center align-center" :maxHeight="height - 24" :minHeight="minHeight">
      <v-card-title class="secondary white--text py-0" @click1="$parent.fitchData()">
        <slot name="title"></slot>
      </v-card-title>
      <v-divider />
      <slot name="data">
        <a-loader v-if="isLoading" :z="1" />
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height1="200"
          transition="fade-transition"
        >
          <apexchart
            v-if="!isLoading && series.length"
            :type="type"
            :height="height - 32"
            :options="chartOptions"
            :series="series"
            @click="$emit('click', $event)"
          ></apexchart>
        </v-lazy>
      </slot>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    defaults: Object,
    model: { type: Object, default: () => {} },
    height: { type: Number, default: 0 },
    series: { type: Array, default: () => [] },
    chartOptions: { type: Object, default: () => {} },
    type: String,
    defaults: Object,
    isLoading: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {
      isActive: false,
      loaded: false,
    };
  },
  created() {},
  computed: {
    minHeight() {
      let h = this.height;
      if (this.$vuetify.breakpoint.name == "xs" && this?.data?.length == 0) {
      }
      return h;
    },
  },
  methods: {},
};
</script>
